import type { RouteComponentProps } from '@reach/router';
import { Redirect } from '@reach/router';
import type { ReactNode, FC } from 'react';

import { useLoginState } from '@xing-com/crate-hooks-use-login-state';

import { getLoginUrl } from '../../utils/url';

type AuthenticatedRouteProps = {
  component?: ReactNode;
};
export const AuthenticatedRoute: FC<
  RouteComponentProps & AuthenticatedRouteProps
> = ({ component, ...rest }) => {
  const { isLoggedIn } = useLoginState();

  if (!isLoggedIn) {
    return (
      <Redirect
        to={getLoginUrl({ location: rest.location?.pathname ?? '' })}
        noThrow
      />
    );
  }

  return component;
};
